const OSS_IMAGE_HOST = '.oss-cn-beijing.aliyuncs.com/'

const PRESETS = Object.freeze({
  thumbnail: 'image/resize,w_480/format,webp/quality,Q_82',
  preview: 'image/resize,w_2000/format,webp/quality,Q_93',
  large: 'image/resize,w_3840/format,webp/quality,Q_96'
})

export function ossImageUrl(url, preset = 'preview') {
  if (!url || typeof url !== 'string' || !url.includes(OSS_IMAGE_HOST)) return url
  if (url.includes('x-oss-process=')) return url
  const process = PRESETS[preset] || PRESETS.preview
  return `${url}${url.includes('?') ? '&' : '?'}x-oss-process=${process}`
}

export function originalImageUrl(url) {
  if (!url || typeof url !== 'string') return url
  try {
    const parsed = new URL(url, window.location.origin)
    parsed.searchParams.delete('x-oss-process')
    return parsed.href
  } catch (error) {
    return url
  }
}
/**
 * OSS 图片地址工具：只负责展示尺寸参数和地址规范化，不改变数据库中的原始 URL。
 */
